import { ZonedDateTime } from '@internationalized/date';
import {
  nowInTimezone,
  startOfDayInTimezone,
  endOfDayInTimezone,
} from '@antimatterhq/ui/utils/zonedDateTimeUtils';

export type TimePreset = {
  label: string;
  getValue: (timezone: string) => {
    start: ZonedDateTime;
    end: ZonedDateTime;
  };
};

export const timePresets: TimePreset[] = [
  {
    label: 'Last hour',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = end.subtract({ hours: 1 });
      return { start, end };
    },
  },
  {
    label: 'Last 24 hours',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = startOfDayInTimezone(end.subtract({ hours: 24 }));
      return { start, end };
    },
  },
  {
    label: 'Last week',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = startOfDayInTimezone(end.subtract({ days: 7 }));
      return { start, end };
    },
  },
  {
    label: 'Last month',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = startOfDayInTimezone(end.subtract({ months: 1 }));
      return { start, end };
    },
  },
  {
    label: 'Last 3 months',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = startOfDayInTimezone(end.subtract({ months: 3 }));
      return { start, end };
    },
  },
  {
    label: 'Last 6 months',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = startOfDayInTimezone(end.subtract({ months: 6 }));
      return { start, end };
    },
  },
];

export interface QuickSelection {
  label: string;
  getValue: (timezone: string) => {
    start: ZonedDateTime;
    end: ZonedDateTime;
  };
}

export const QUICK_SELECTIONS: QuickSelection[] = [
  {
    label: 'Today',
    getValue: (timezone: string) => {
      const now = nowInTimezone(timezone);
      return {
        start: startOfDayInTimezone(now),
        end: endOfDayInTimezone(now),
      };
    },
  },
  {
    label: 'Yesterday',
    getValue: (timezone: string) => {
      const yesterday = nowInTimezone(timezone).subtract({ days: 1 });
      return {
        start: startOfDayInTimezone(yesterday),
        end: endOfDayInTimezone(yesterday),
      };
    },
  },
  {
    label: 'Last 7 days',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = end.subtract({ days: 7 });
      return {
        start: startOfDayInTimezone(start),
        end: endOfDayInTimezone(end),
      };
    },
  },
  {
    label: 'Last 30 days',
    getValue: (timezone: string) => {
      const end = nowInTimezone(timezone);
      const start = end.subtract({ days: 30 });
      return {
        start: startOfDayInTimezone(start),
        end: endOfDayInTimezone(end),
      };
    },
  },
];
